import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import ChartLine from '@/components/chart/chart-line'
import { onMounted, ref, watch } from 'vue'
import communityDashboardService from '@/services/community-dashboard.services'
import { useRoute } from 'vue-router'
import { convertDateChartToJapanese } from '@/constants/datepicker'

export default /*#__PURE__*/_defineComponent({
  props: {
  step: {
    type: Number,
  },
  title: {
    type: String,
  },
  // 2022/11/01 CW-PhuongTT Fix UAT#4952: CB10 (Ph2-R20221104)
  // titleChart: {
  //   type: String,
  // },
  data_type: {
    type: Number,
  },
  date: {
    type: Object,
  },
},
  setup(__props) {

const props = __props

const route = useRoute()
const labelCharts = ref([])
const dataEmployees = ref([])
const dataAlumnus = ref([])
const dataCommunityAdmin = ref([])
const loading = ref(true)
const errorCallApi = ref(false)

onMounted(() => {
  getDataChart()
})
watch(
  () => props.date?.from,
  () => {
    getDataChart()
  }
)
watch(
  () => props.date?.to,
  () => {
    getDataChart()
  }
)
const getDataChart = async () => {
  try {
    loading.value = true
    const res = await communityDashboardService.getPostsGraph(route?.params?.id, {
      from: props.date?.from ?? '',
      to: props.date?.to ?? '',
      data_type: props.data_type,
    })
    loading.value = false
    if (res.data?.success) {
      errorCallApi.value = false
      labelCharts.value = convertDateChartToJapanese(res.data.data.labels)
      if (res.data?.data?.employees) dataEmployees.value = res.data.data.employees
      if (res.data?.data?.alumnus) dataAlumnus.value = res.data.data.alumnus
      if (res.data?.data?.community_admins) dataCommunityAdmin.value = res.data?.data?.community_admins
    } else {
      errorCallApi.value = true
    }
  } catch (error) {
    loading.value = true
    console.log(error)
  }
}

const handleDataChart = (alumnus, employees, community_admins) => {
  if ([1, 2, 3, 4].includes(props.data_type)) {
    return { dataAlumnus: alumnus, dataEmployees: employees }
  } else if (props.data_type === 5) return { dataAlumnus: alumnus }
  else return { dataCommunityAdmin: community_admins }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(ChartLine), {
    errorCallApi: errorCallApi.value,
    loading: loading.value,
    step: __props.step,
    labelCharts: labelCharts.value,
    dataChart: handleDataChart(dataAlumnus.value, dataEmployees.value, dataCommunityAdmin.value),
    title: __props.title,
    getDataChart: getDataChart,
    date: __props.date
  }, null, 8, ["errorCallApi", "loading", "step", "labelCharts", "dataChart", "title", "date"]))
}
}

})